import React from 'react';
import { FiSearch, FiX } from 'react-icons/fi';
import { useSolution } from '../../context/SolutionContext';

const SearchBar = () => {
  const { state, dispatch } = useSolution();
  
  return (
    <div className="relative">
      <FiSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
      <input
        type="text"
        value={state.searchQuery}
        onChange={(e) => dispatch({ type: 'SET_SEARCH_QUERY', payload: e.target.value })}
        placeholder="Search components..."
        className="w-full pl-10 pr-10 py-3 bg-white border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
      />
      {state.searchQuery && (
        <button
          onClick={() => dispatch({ type: 'SET_SEARCH_QUERY', payload: '' })}
          className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
        >
          <FiX className="w-5 h-5" />
        </button>
      )}
    </div>
  );
};

export default SearchBar;